import { logError } from "../../../shared/functions/misc";
import * as Fns from "../shared/functions";
import Config from "../../../config";
import m from "mithril";
const RouteLink = m.route.Link;
export class View {
    view() {
        try {
            const jwt = m.route.param("jwt") || null;
            const agencynr = m.route.param("agencynr") || null;
            const isLoggedIn = Fns.isLoggedIn(agencynr, jwt);
            return (m("section", { class: "form login-form" },
                !isLoggedIn && (m("div", null,
                    m("p", { class: "alert alert--danger alert--icon mb3" },
                        m("i", { class: "fas fa-times" }),
                        "Sie konnten leider nicht eingeloggt werden. Evtl. ist der Link bereits abgelaufen. Bitte versuchen Sie es erneut mit einem frisch zugeschickten Anmeldelink."),
                    m("div", { class: "tr" },
                        m(RouteLink, { href: "/agentur", class: "btn btn--link", title: "Zur\u00FCck zur Loginseite" },
                            "zum Login ",
                            m("i", { class: "fas fa-arrow-right" }))))),
                isLoggedIn && (m("div", null,
                    m("p", { class: "alert alert--success alert--icon mb3" },
                        m("i", { class: "fas fa-check" }),
                        "Sie sind angemeldet!"),
                    m("div", { class: "tr" },
                        m(RouteLink, { href: "/agentur/stellvertretung", class: "btn btn--success", title: "Weiter zur Buchungsabfrage" },
                            "Weiter ",
                            m("i", { class: "fas fa-arrow-right" })))))));
        }
        catch (e) {
            logError(e);
            location.href = Config.urls.FE_ERROR;
        }
    }
}
export default View;
